






























































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { http } from "@/shared/https";
// import Axios from "axios";
import * as _ from "lodash";

/*
 * Component's properties and events
 */
@Component({
  components: {},
})
export default class WorkFlowStepDialogComponents extends Vue {
  /*
   * Component's props
   */

  @Prop() readonly wfStepMappingDialog!: boolean;
  //  @Prop()  wfStepMappingDialog: boolean = false;
  @Prop() readonly componentKeyId!: 0;
  // public wfStepMappingDialog: boolean = false;
  public workFlowStepheaders: any = [];
  public workFlowSteps: any = [];
  public selected: boolean = false;
  public selectAll: boolean = false;
  public stepHierarchy = [];
  public dataInitialized: boolean = false;
  public inpukey: number = 1;
  public selectedSteps: string = "";
  public workFlowStepsSelected: any = [];

  data() {
    return { wfStepMappingDialog: false };
  }

  /*
   * Component's variables
   */

  updateRowRecord(step, sthierarchy, chkSelected, selectedcolumn) {
    var record = null,
      self = this,
      field = null;
    var arrSteps = [];
    //  let strStepHierarchy: any = null;
    let stepHierarchy: any = null;
    let arrStepHierarchy = [];
    var stepId = step.WorkFlowStepId;
    if (sthierarchy.length > 0) {
      // @ts-ignore
      stepHierarchy = sthierarchy.find((x) => x);
      // @ts-ignore
      // strStepHierarchy = stepHierarchy.StepHierarchy.split(',');
    }

    // if (chkSelected == 1) {
    // if (step.inpukey == 1 || (stepHierarchy && (stepHierarchy.workflowstepid == selectedcolumn.WorkFlowStepId))) {
    if (step.inpukey == 1 || stepHierarchy) {
      if (stepHierarchy.StepHierarchy.toString().length > 1)
        arrStepHierarchy = stepHierarchy.StepHierarchy.split(",").map(Number);
      else if (stepHierarchy.StepHierarchy.toString().length == 1)
        // @ts-ignore
        arrStepHierarchy.push(parseInt(stepHierarchy.StepHierarchy));
      //  arrStepHierarchy = stepHierarchy.StepHierarchy.split(',').map(Number);

      if (_.includes(arrStepHierarchy, selectedcolumn.WorkFlowStepId)) {
        // @ts-ignore
        const index: number = arrStepHierarchy.indexOf(
          selectedcolumn.WorkFlowStepId
        );
        if (index !== -1) {
          arrStepHierarchy.splice(index, 1);
        }
        // arrStepHierarchy.pop(selectedcolumn.WorkFlowStepId);
        stepHierarchy.StepHierarchy = arrStepHierarchy.join(",");
        if (stepHierarchy.StepHierarchy == "") {
          // @ts-ignore
          //remove empty elememnt with StepHierarchy="" from object
          this.stepHierarchy = this.stepHierarchy.filter(
            (obj) => obj.StepHierarchy !== ""
          );
          //this.stepHierarchy.pop({ "workflowstepid": step.WorkFlowStepId, "StepHierarchy": "" });
        }
      } else {
        // @ts-ignore
        arrStepHierarchy.push(selectedcolumn.WorkFlowStepId);
        stepHierarchy.StepHierarchy = arrStepHierarchy.join(",");
        // @ts-ignore
      }
    } else {
      let newStepHierarchyJson = {
        workflowstepid: null,
        StepHierarchy: null,
      };
      // @ts-ignore
      this.stepHierarchy.push({
        workflowstepid: step.WorkFlowStepId,
        StepHierarchy: selectedcolumn.WorkFlowStepId,
      });
    }
  }

  selectWorkflowSteps(header, step, sthierarchy) {
    if (sthierarchy) {
      let arrStepHierarchy = [];
      if (sthierarchy.length > 0) {
        // @ts-ignore
        let strStepHierarchy = sthierarchy.find((x) => x);
        // @ts-ignore
        if (strStepHierarchy.StepHierarchy.toString().length > 1)
          arrStepHierarchy = strStepHierarchy.StepHierarchy.split(",").map(
            Number
          );
        else if (strStepHierarchy.StepHierarchy.toString().length == 1)
          // @ts-ignore
          arrStepHierarchy.push(parseInt(strStepHierarchy.StepHierarchy));
        if (_.includes(arrStepHierarchy, step.WorkFlowStepId)) {
          step.inpukey = 1;
        }
        //else if (step.inpukey == 1) {
        //    step.inpukey = 1;
        //}
        else {
          step.inpukey = 0;
        }
      } else {
        step.inpukey = 0;
      }
    } else {
      step.inpukey = 0;
    }
  }

  mounted() {
    let field: any = null;
    let strStepHierarchy: any = "";
    let _steps: any = null;
    let arrSteps = [];
    let id = window.location.hash.split("#")[1];
    // this.wfStepMappingDialog = this.$store.state.workFlowPermissionIndex.stepMappingDialog;
    var workFlowDefId = parseInt(id);

    var permissionId = this.$store.state.workFlowPermissionIndex.wfPermissionId;
    http
      .post(
        "/api/WorkflowStepMapping/GetStepHierarchy/?workflowPermissionId=" +
          permissionId,
        null
      )
      .then((recordStep) => {
        try {
          if (recordStep.data.Records) {
            this.stepHierarchy = JSON.parse(recordStep.data.Records);
          }
        } catch (error) {}
      })
      .catch((error) => {});
    http
      .post(
        "/api/WorkflowStepMapping/GetSteps/?workFlowDefinitionId=" +
          workFlowDefId,
        null
      )
      .then((record) => {
        try {
          this.workFlowStepheaders = record.data.stepheaders;
          this.workFlowSteps = record.data.Options;
          this.dataInitialized = true;
        } catch (error) {}
      })
      .catch((error) => {});
  }

  saveStepHierarchy() {
    let dashboard = this.$store.state.dashboard;
    let newstepHeierachy = this.stepHierarchy;
    let permissionId = this.$store.state.workFlowPermissionIndex.wfPermissionId;
    // let permissionId = this.$store.state.permissionFormIndex.componentKeyId
    http
      .post(
        "/api/WorkflowStepMapping/SaveStep/?workflowPermissionId=" +
          permissionId,
        newstepHeierachy,
        "application/json"
      )
      .then((record) => {
        if (record.data.Result == "OK") {
          dashboard.color = "success";
          dashboard.text = record.data.Message;
          dashboard.snackbar = true;
        } else {
          dashboard.color = "error";
          dashboard.text = record.data.Message;
          dashboard.snackbar = true;
        }
      })
      .catch(function () {
        console.log("FAILURE!!");
      });
  }

  closeDialog() {
    // @ts-ignore
    //this.wfStepMappingDialog = false;
    this.$store.state.workFlowPermissionIndex.stepMappingDialog = false;
  }
}
